module.exports = __webpack_public_path__ + "img/select-check-on-disabled.65774fa0.svg";